import * as React from 'react';
import { styled } from '@mui/system';

import { CloseButton } from 'components/Buttons';

const StyledCloseButton = styled(CloseButton)(({ theme }) => ({
  float: 'right',
  marginLeft: theme.spacing(2),
  marginBottom: theme.spacing(2)
}));

export function NotificationModalCloseButton(props) {
  return <StyledCloseButton {...props} />;
}
